import React,{useState,useEffect,useCallback} from 'react'
import {URL} from '../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { invokeCancelDates, invokeReservations, invokeDeletedBookings as invokeDeletedBookingsFromApi } from '../ServiceCalls/ApiCalls';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AdminComponent.css'
import { lightFormat } from 'date-fns';


function DeletedBookingsComponent() {

  const navigate = useNavigate()
  const user_info = JSON.parse(localStorage.getItem('user'))
  const[deletedBookings,setDeletedBookings] = useState([])
  const[searchDate,setSearchDate] = useState('') // Changed to empty string for initial state
  const[searchTxn,setSearchTxn] = useState('') // Added for transaction search
  const[startDate,setStartDate] = useState('')
  const[endDate,setEndDate] = useState('')
  const[minDate,setMinDate] = useState('')
  const[maxDate,setMaxDate] = useState('')
  const[bookingId,setBookingId]=useState('')
  const[rowId,setRowId]=useState(0)
  const[searchText,setSearchText] = useState('')
  const[startTime,setStartTime] = useState('')
  const[endTime,setEndTime] = useState('')
  const[showEditComponent,setShowEditComponent] = useState(false)
  const[displayValidation,setDisplayValidation] = useState(false)
  const[dateSelected,setDateSelected] = useState(new Date().toLocaleDateString("fr-CA"))
  const[currentDate,setCurrentDate] = useState(new Date().toLocaleDateString("fr-CA"))
  const[bookingRowEdited,setBookingRowEdited] = useState({})
  const[courtBooked,setCourtBooked] = useState('')
  const[price,setPrice] = useState(0.00)
  const[cancelDates,setCancelDates] = useState([])
  const[isLoading,setIsLoading] = useState(true)
  const[isRefreshing,setIsRefreshing] = useState(false)
  const [formData, setFormData] = useState({
    discount: 0,
    netPrice:0,
    contact: '',
    email: '',
    userName: '',
    booking_date_end: ''
});

  const invokeDeletedBookings = useCallback(async () =>{
        setIsLoading(true);
        try {
            const deletedBookingsResponse = await invokeDeletedBookingsFromApi(); // Use the imported service call
            const new_deleted_booking_response = deletedBookingsResponse.map(item =>{
                return {...item,isEditing:false}
            })
            setDeletedBookings(new_deleted_booking_response)
        } catch (error) {
            console.error('Error fetching deleted bookings:', error);
            toast.error('Failed to load deleted bookings', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setIsLoading(false);
        }
    }, [searchText, searchTxn, searchDate]); // Dependencies for useCallback

  useEffect(() =>{
    if(!localStorage.getItem('user')){
        navigate('/')
    }
    invokeDeletedBookings()
  },[invokeDeletedBookings, navigate]) // Dependencies for useEffect
  const refreshBookings = async () => {
    setIsRefreshing(true);
    try {
      const deletedBookingsResponse = await invokeDeletedBookingsFromApi(); // Use the new service call
      const new_deleted_booking_response = deletedBookingsResponse.map(item =>{
          return {...item,isEditing:false}
      })
      setDeletedBookings(new_deleted_booking_response)

      toast.success('Deleted bookings refreshed successfully!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error('Error refreshing deleted bookings:', error);
      toast.error('Failed to refresh deleted bookings', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsRefreshing(false);
    }
  };

  const options = (method = "GET",body) =>{
    return {
        method,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    }
  }

  const toggleRow = (row,rid) => {
     setShowEditComponent(false)
     setBookingRowEdited({...row})
     setBookingId(row._id)
     setRowId(rid)
     setStartDate('')
     setEndDate('')
     setDisplayValidation(false)
     setMinDate(row.booking_date_start)
     setMaxDate(row.booking_date_end)
  }
  const deleteBooking = async(bookingid,rowid) => {

    window.confirm('Are you Sure You wanna Permanently Delete the Record at Row-No - '+`${rowid+1}`)
    try{
        const delete_booking_response = await fetch(`${URL}/deleted-bookings/${bookingid}`, options("DELETE"));
        if(delete_booking_response.ok){
            const new_deleted_bookings = deletedBookings.filter(b => b._id !== bookingid)
            const dataDelete = [...new_deleted_bookings];
            setDeletedBookings([...dataDelete])
            toast.success('🦄 Wow Row Permanently Deleted!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }catch(err){
        console.log(err)
        toast.error('🦄 OOps Permanent Deletion Failed!', {
          position: "top-right", autoClose: 5000, hideProgressBar: false,
          closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored",
        });
    }
  }

  return (
      <div className="admin-panel">
          <div className='container admin-container'>
              <div className="row mt-5">
                <div className="col-md-12 col-sm-12">
                  <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="mb-1">
                        <i className="fa fa-trash text-danger me-2"></i>
                        Deleted Bookings ({deletedBookings.length})
                      </h3>
                      <p className="text-muted">View and permanently delete booking records</p>
                    </div>
                    <div className="failed-bookings-actions">
                      <button
                        className="btn btn-outline-secondary me-2"
                        onClick={refreshBookings}
                        disabled={isRefreshing}
                      >
                        {isRefreshing ? (
                          <>
                            <i className="fa fa-spinner fa-spin me-1"></i>
                            Refreshing...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-refresh me-1"></i>
                            Refresh
                          </>
                        )}
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => navigate('/user')}
                      >
                        <i className="fa fa-arrow-left me-1"></i>
                        Back to Dashboard
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter Section */}
              <div className="mb-4">
                  <div className="table-responsive">
                      <div className="d-flex align-items-center gap-3 mb-3" style={{padding: '1rem', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '0.375rem'}}>
                          <input
                              type="search"
                              className='form-control'
                              name="search"
                              placeholder='Search User...'
                              value={searchText}
                              onChange={e => setSearchText(e.target.value)}
                              id="search"
                              style={{flex: '1'}}
                          />
                          <input
                              type="search"
                              className='form-control'
                              name="searchTxn"
                              placeholder='Search Transaction...'
                              value={searchTxn}
                              onChange={e => setSearchTxn(e.target.value)}
                              id="searchTxn"
                              style={{flex: '1'}}
                          />
                          <input
                              type="date"
                              value={searchDate}
                              onChange={e => setSearchDate(e.target.value)}
                              className='form-control'
                              style={{flex: '1'}}
                          />
                          <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => {
                                  setSearchText('');
                                  setSearchTxn('');
                                  setSearchDate('');
                              }}
                              disabled={!searchText && !searchTxn && !searchDate}
                              style={{minWidth: '120px'}}
                          >
                              Clear Filters
                          </button>
                      </div>

                      {/* Filter Summary */}
                      {(searchText || searchTxn || searchDate) && (
                          <div className="mb-3" style={{padding: '0.5rem 1rem', backgroundColor: '#e9ecef', borderRadius: '0.375rem'}}>
                              <small className="text-muted">
                                  Active Filters:
                                  {searchText && (
                                      <span className="badge bg-primary ms-1 me-1">
                                          User: "{searchText}"
                                      </span>
                                  )}
                                  {searchTxn && (
                                      <span className="badge bg-info ms-1 me-1">
                                          Transaction: "{searchTxn}"
                                      </span>
                                  )}
                                  {searchDate && (
                                      <span className="badge bg-success ms-1 me-1">
                                          Date: {searchDate}
                                      </span>
                                  )}
                                  | Showing filtered results
                              </small>
                          </div>
                      )}
                  </div>
              </div>

              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                  <div className="text-center">
                    <div className="spinner-border text-danger" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Loading deleted bookings...</p>
                  </div>
                </div>
              ) : (
                <div className="customer-table table-responsive">
                  <table className='table table-bordered table-hover my-5 admin-tab'>
                      <thead className="table-warning text-center">
                          <tr>
                            <th>S.No</th>
                            <th>Txn#</th>
                            <th>User Name</th>
                            <th>Booking Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Court</th>
                            <th>Total Price-A$</th>
                            <th>Discount %</th>
                            <th>Net Price</th>
                            <th>Payment Mode</th>
                            <th>Created On</th>
                            <th>Contact</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            deletedBookings.length > 0 ? deletedBookings.filter(item =>{
                                const textMatch = searchText.toLowerCase() === '' ? item : item?.userName?.toLowerCase().includes(searchText.toLowerCase());
                                const dateMatch = searchDate === '' ? item : new Date(item?.booking_date).toLocaleDateString() === new Date(searchDate).toLocaleDateString();
                                const txnMatch = !searchTxn ? item : item?.bookingID?.toLowerCase()?.includes(searchTxn.toLowerCase());
                                if(textMatch && dateMatch && txnMatch)
                                    return textMatch && dateMatch && txnMatch;
                              })
                              .sort((a, b) => new Date(a.booking_date) < new Date(b.booking_date) ? 1 : -1)
                              .map((r, i) => (<tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{r.bookingID}</td>
                                  <td title={r.userName}>{r.userName}</td>
                                  <td>{r.booking_date}</td>
                                  <td>{r.booking_time_start}</td>
                                  <td>{r.booking_time_end}</td>
                                  <td>{r.booking_item}</td>
                                  <td className="text-end" title={`Total: A$${r.grand_total?.toFixed(2)}`}>
                                    A${r.grand_total?.toFixed(2)}
                                  </td>
                                  <td className="text-center" title={`Discount: ${r.discount}%`}>
                                    {r.discount}%
                                  </td>
                                  <td className="text-end" title={`Net Price: A$${r.net_price?.toFixed(2)}`}>
                                    A${r.net_price?.toFixed(2)}
                                  </td>
                                  <td>
                                  <span className={r.booking_status === 'UnPaid' ? 'bg-danger text-white' : r.booking_status === 'Complimentary' ? 'bg-info text-white' : 'bg-success text-white'}>{r.booking_status}</span>
                                  </td>
                                  <td title={`Created: ${r.createdBy?.split('|')[0]} on ${r.createdBy?.split('|')[1]}`}>
                                    <div className="created-info">
                                      <div className="created-by">{r.createdBy?.split('|')[0]}</div>
                                      <div className="created-date">{r.createdBy?.split('|')[1]}</div>
                                    </div>
                                  </td>
                                  <td title={`Contact: ${r.contact}, Email: ${r.email}`}>
                                    <div className="contact-info">
                                      <div className="contact-phone">{r.contact}</div>
                                      <div className="contact-email">{r.email}</div>
                                    </div>
                                  </td>
                                  <td>
                                      <div className="action-buttons">
                                        <i
                                            onClick={() => deleteBooking(r._id, i)}
                                            className='fa fa-trash'
                                            title="Permanently Delete Booking"></i>
                                      </div>
                                  </td>
                                </tr>)
                            )
                            :
                            <tr>
                                <td colSpan={14} className='text-center'>
                                    <p>No Deleted Booking Records Available...</p>
                                </td>
                            </tr>
                        }
                    </tbody>
                  </table>
                </div>
              )}
          </div>


                <button
                  className="btn btn-primary back-to-top-btn"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  title="Back to Top"
                >
                  <i className="fa fa-arrow-up"></i>
                </button>

                <ToastContainer/>
            </div>
  )
}

export default DeletedBookingsComponent
